import styled from 'styled-components';

export const StyledActiveBadge = styled.div`
  position: sticky;
  top: 57px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9;
  background: #ebeff3;
  padding: 10px 0;
`;
